
















































































































































































































































































































































































import Vue from 'vue'
import { withDefault } from '@/components/exercises/measure/filters'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as PatientActionNames } from '@/store/modules/patient/keys'
import { COMMON_ICONS_BASE64, convertBase64ForSrc } from '@/utils/image-utils'
import { AppGetterNames } from '@/store/modules/app/keys'

import {
  ActionNames as MonthlyCostsActionNames,
  GetterNames as MonthlyCostsGetterNames,
} from '@/store/modules/monthly-costs/keys'

import { ONE_DAY } from '@/utils/time'
import { getSelectedYearMonthsArray } from '@/constants/site-stats'
import moment from 'moment-timezone'
import InputWithSaveAndUndo from '@/components/sub-components/InputWithSaveAndUndo.vue'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import {
  CashFlowCalculator,
  MIN_TIMESTAMP,
  MonthlyCapexCostTypes,
  MonthlyOpexCostTypes,
  SiteCashFlowStats,
} from '@/constants/cash-flow'
import { toCurrency } from '../../store/utils/converter'
import CashFlowSummary from '@/components/site-stats/CashFlowSummary.vue'
import { inc } from 'ramda'
import { SiteStatsAttributes } from '@/jsonapi/SiteStats'

type ComponentData = {
  isLoading: boolean
  initialLoaded: boolean
  cashFlowCalculator: CashFlowCalculator | null

  oneTimeRevHomesHidden: boolean
  recurrentRevHomesHidden: boolean
  stripRevHomesHidden: boolean
}

type MonthData = {
  str: string
  year: number
  month: number
}

export default Vue.extend({
  components: { CashFlowSummary, InputWithSaveAndUndo },
  filters: { withDefault },
  props: {
    // siteStats: {
    //   type: Array,
    //   default: () => [],
    // },
    activeRealSites: {
      type: Array,
      required: true,
    },
    // just to trigger a re-render
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      default: moment().valueOf(),
    },
  },
  data(): ComponentData {
    return {
      isLoading: false,
      initialLoaded: false,
      cashFlowCalculator: null,

      oneTimeRevHomesHidden: true,
      recurrentRevHomesHidden: true,
      stripRevHomesHidden: true,
    }
  },
  computed: {
    ...mapGetters({
      monthlyCostsData: `${ModuleNames.monthlyCosts}/${MonthlyCostsGetterNames.costs}`,
    }),
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isExecUser: AppGetterNames.isExecUser,
    }),
    ...mapGetters(ModuleNames.siteStats, [SiteStatsGetterNames.siteStatses]),

    siteStats(): SiteStatsAttributes[] {
      return this[SiteStatsGetterNames.siteStatses]
    },

    isToDateProfitLossTable(): boolean {
      return this.startTimestamp <= MIN_TIMESTAMP
    },
    includeMonths(): boolean {
      return !this.isToDateProfitLossTable
    },
    individualHomesSupported(): boolean {
      return !this.isToDateProfitLossTable
    },

    cashFlowTitle(): string {
      let monthCount = getSelectedYearMonthsArray(this.startTimestamp, this.endTimestamp).length
      let rangeDesc = ''
      if (monthCount === 1) {
        rangeDesc = moment(this.startTimestamp).format('MMM')
      } else if (monthCount < 12) {
        rangeDesc = moment(this.startTimestamp).format('MMM') + ' - ' + moment(this.endTimestamp).format('MMM')
      } else if (this.isToDateProfitLossTable) {
        rangeDesc = 'To-date'
      } else {
        rangeDesc =
          moment(this.startTimestamp).format('MMM YYYY') + ' - ' + moment(this.endTimestamp).format('MMM YYYY')
      }
      return 'Cash Flow: ' + rangeDesc
    },
    cashFlowSummaryTitle(): string {
      let monthCount = getSelectedYearMonthsArray(this.startTimestamp, this.endTimestamp).length
      let rangeDesc = ''
      if (monthCount === 1) {
        rangeDesc = moment(this.startTimestamp).format('MMM')
      } else if (monthCount < 12) {
        rangeDesc = moment(this.startTimestamp).format('MMM') + ' - ' + moment(this.endTimestamp).format('MMM')
      } else if (this.isToDateProfitLossTable) {
        rangeDesc = 'To-date'
      } else {
        rangeDesc =
          moment(this.startTimestamp).format('MMM YYYY') + ' - ' + moment(this.endTimestamp).format('MMM YYYY')
      }
      return 'Cash Flow Summary: ' + rangeDesc
    },
    months(): string[] {
      return this.cashFlowCalculator?.months || []
    },
    monthsDetails(): MonthData[] {
      if (!this.siteStats || this.siteStats.length === 0) {
        return []
      }
      return getSelectedYearMonthsArray(this.startTimestamp, this.endTimestamp).map(monthStr =>
        this.getMonthData(moment(monthStr + '-01', 'YYYYMM-DD').valueOf())
      )
    },
    emrCostsPerMonth(): object {
      return this.cashFlowCalculator?.getEmrCostsPerMonth() || {}
    },
    totalRevenuesPerMonth(): object {
      return this.cashFlowCalculator?.getTotalRevenuesPerMonth() || {}
    },
    totalExpensesPerMonth(): object {
      return this.cashFlowCalculator?.getTotalExpensesPerMonth() || {}
    },
    convertedSitesForDataTable(): SiteCashFlowStats[] {
      return this.cashFlowCalculator?.siteCashFlowStats
    },
    totalIncome(): number {
      return this.cashFlowCalculator?.getTotalRevenue() || 0
    },
    totalExpenses(): number {
      return this.cashFlowCalculator?.getTotalExpenses() || 0
      // return Object.values(this.totalExpensesPerMonth).reduce((a: number, b: number) => a + b, 0) as number
    },
    iconImage(): string {
      return convertBase64ForSrc(COMMON_ICONS_BASE64.INFO_CIRCLE)
    },
    showLoading(): Boolean {
      //combines loading states from props and data
      return this.isLoading
    },
    costsByMonth(): object {
      let cbm = this.cashFlowCalculator?.getCustomCostsByMonth()
      console.log('got costs by month: ', cbm, this.cashFlowCalculator)
      return cbm || {}
    },
  },
  watch: {
    startTimestamp: {
      immediate: true,
      async handler(val, oldVal) {
        await this.fetchData()
      },
    },
    endTimestamp: {
      immediate: true,
      async handler(val, oldVal) {
        await this.fetchData()
      },
    },
  },
  async mounted() {
    console.log('mounted')
    //await this[PatientActionNames.getPatients]()
    await this.fetchData()
  },
  methods: {
    inc,
    toCurrency,
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.monthlyCosts, [MonthlyCostsActionNames.getCosts]),
    ...mapActions(ModuleNames.monthlyCosts, [MonthlyCostsActionNames.patchCosts]),
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    loadSiteStats(payload: { startTimestamp: number; endTimestamp: number }) {
      this.reloading = true
      this.startTimestamp = payload.startTimestamp
      this.endTimestamp = payload.endTimestamp
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      this[SiteStatsActionNames.getSiteStatses]({
        startTimestamp: Math.max(lastYearTimestamp, payload.startTimestamp - OFFSET_HOURS_TIMESTAMP),
        endTimestamp: payload.endTimestamp,
      }).then(() => (this.reloading = false))
    },
    // ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    async fetchData() {
      this.isLoading = true
      console.log(new Date(), 'fetchData()!')
      // await this[SiteStatsActionNames.getSiteStatses]()
      let getCostsFn = this[MonthlyCostsActionNames.getCosts]({
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
      })
      let getStatsFn = this[SiteStatsActionNames.getSiteStatses]({
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
      })
      await Promise.all([getCostsFn, getStatsFn])

      console.log('got costs: ', this.monthlyCostsData, ', stats: ', this.siteStats)
      this.cashFlowCalculator = new CashFlowCalculator(
        this.siteStats,
        this.monthlyCostsData,
        this.startTimestamp,
        this.endTimestamp
      )
      if (this.isToDateProfitLossTable) {
        this.cashFlowCalculator.skipEmptyMonths = true
      }

      this.isLoading = false
      this.initialLoaded = true
    },

    roundTo1DecimalPlace(value) {
      return Math.round(10 * value) / 10
    },
    getMonthStr(timestamp: number): string {
      if ((this.cashFlowCalculator?.numberOfMonths || 0) > 11) {
        return moment.utc(timestamp).format('MMM YYYY')
      } else {
        return moment.utc(timestamp).format('MMM')
      }
    },
    getMonthData(timestamp: number): MonthData {
      return {
        str: this.cashFlowCalculator?.getMonthStr(timestamp) ?? 'N/A',
        year: parseInt(moment.utc(timestamp).format('YYYY')),
        month: parseInt(moment.utc(timestamp).format('MM')),
      }
    },
    range(min, max): Array<number> {
      let len = max - min + 1
      let arr = new Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = min + i
      }
      return arr
    },
    sumCostOfType(type): number {
      let total = 0
      for (let month in this.costsByMonth) {
        if (type in this.costsByMonth[month]) {
          total += this.costsByMonth[month][type]
        }
      }
      return total
    },
    getOpexCostNotOfTypes(types: String[], specificMonth: string | null = null): number {
      let total = 0
      for (let month in this.costsByMonth) {
        console.log(`getOpexCostNotOfTypes: '${month}'`)
        console.log(`getOpexCostNotOfTypes: '${month}', '${specificMonth}'`)
        if (specificMonth && month != specificMonth) {
          continue
        }

        for (let type in this.costsByMonth[month]) {
          console.log(`checking type ${type}...`)
          if (!(type in MonthlyOpexCostTypes)) {
            console.log(`type ${type} not opex... skipping`)
            continue
          }
          console.log(`checking type ${type} pt 2...`)
          if (!types.includes(type)) {
            let monthTypeCost = this.costsByMonth[month][type]
            console.log(`Adding ${monthTypeCost} ${type} for ${month}`)
            total += monthTypeCost
          }
          console.log(`done with type ${type}...`)
        }
      }
      console.log('getOpexCostNotOfTypes returning: ', total)
      return total
    },
    getCapexCostNotOfTypes(types: String[], specificMonth: string | null = null): number {
      let total = 0
      for (let month in this.costsByMonth) {
        if (specificMonth && month != specificMonth) {
          continue
        }
        for (let type in this.costsByMonth[month]) {
          if (!(type in MonthlyCapexCostTypes)) {
            continue
          }
          if (!types.includes(type)) {
            total += this.costsByMonth[month][type]
          }
        }
      }
      return total
    },
    async saveCost(monthData, type, value): Promise<void> {
      await this[MonthlyCostsActionNames.patchCosts]({
        id: null,
        attributes: {
          month: monthData.month,
          year: parseInt(monthData.year),
          type: type,
          cost: parseFloat(value),
        },
      })
        .catch(error => {
          if (error && error.response && error.response.status == 403) {
            alert("Sorry, you're not authorized to modify costs.")
          } else {
            alert('Failed to save costs. Please try again later.')
          }
          return
        })
        .then(() => {
          this.initialLoaded = false
          this.fetchData()
        })
    },
  },
})
